import { getAuth } from "firebase/auth";
import { getReadyAuthUser } from "~/utils/auth/waitForAuthReady";
import {
  ActionFunctionArgs,
  LoaderFunctionArgs,
  redirect,
} from "react-router-dom";
import { apiClient, TenantDetailsLeaseLoaderResult } from "~/services/apiClient";
import { LoaderData } from "~/types";
import { FormattedLeaseData } from "~/types/lease";
import { INTENTS, loadCookiesData, resolveActorUserName } from "~/utils";
import * as APITypes from "~/API";

export const TenantDetailsLeaseLoader = async ({
  request,
  params,
}: LoaderFunctionArgs) => {
  const auth = getAuth();
  const user = await getReadyAuthUser();
  if (!user) return redirect("/explore");
  const authAccessInfo = await loadCookiesData(user.uid);
  if (!authAccessInfo.success) return redirect("/explore");

  const tenantID = params.tenantID || "";

  const result = await apiClient.loader<TenantDetailsLeaseLoaderResult>(
    "tenant-details-lease",
    { id: tenantID }
  );

  if (!result.success || !result.data) {
    console.error("Failed to load tenant details lease:", result.error);
    throw new Error(
      result.error ?? "Failed to load tenant details lease"
    );
  }

  const data = result.data;
  const userName = await resolveActorUserName(user, authAccessInfo);

  return {
    tenantInfo: { success: true, data: data.tenantInfo } as LoaderData<APITypes.Tenant>,
    ownerID: user?.uid || "",
    ownerType: APITypes.OwnerType.User,
    userName,
    formattedLeaseList: data.formattedLeaseList as FormattedLeaseData[],
  };
};

export type TenantDetailsLeaseLoaderType = {
  tenantInfo: LoaderData<APITypes.Tenant>;
  ownerID: string;
  ownerType: APITypes.OwnerType;
  userName: string;
  formattedLeaseList: FormattedLeaseData[];
  activeKey: string;
};

export const TenantDetailsLeaseAction = async ({
  request,
  params,
}: ActionFunctionArgs) => {
  const formData = await request.formData();
  const intent = formData.get("intent");
  const auth = getAuth();
  const user = await getReadyAuthUser();
  if (!user) return null;

  switch (intent) {
    case INTENTS._delete_lease: {
      const bodyStr = formData.get("body") as string;
      const payload = bodyStr ? JSON.parse(bodyStr) : {};
      const result = await apiClient.sendIntent<{
        nextLeaseID?: string;
        deleted?: boolean;
      }>(INTENTS._delete_lease, {
        id: payload.id,
        _version: payload._version,
        ...payload,
      });
      if (!result.success) return { success: false, error: result.error };
      return result;
    }
    case INTENTS._terminate_lease: {
      const payload = JSON.parse(formData.get("body") as string);
      const result = await apiClient.sendIntent<APITypes.Lease>(
        INTENTS._terminate_lease,
        { id: payload.leaseID, leaseID: payload.leaseID, ...payload }
      );
      if (!result.success) return { success: false, error: result.error };
      return result;
    }
    // case INTENTS._add_lease: {
    //   const payload = JSON.parse(formData.get("body") as string);
    //   const date = new Date();
    //   const application = await addApplication(date.toUTCString());
    //   if (!application.success) {
    //     return application;
    //   }

    //   const result = await addLease({
    //     payload: {
    //       ...payload,
    //       userID: user?.uid || "",
    //       entityID: tenantID,
    //       entityType: "unit",
    //     },
    //     applicationID: application.data.id,
    //     backgroundCheckID: "",
    //     moveInID: "",
    //     moveOutID: "",
    //   });
    //   return result;
    // }
  }
  return null;
};
